import { Like } from './theSource';
import { UserSummary } from './user';

export interface Forum {
    pk: string;
    sk: string;
    username: string;
    name: string;
    description: string;
    topicCount: number;
    createdAt: string;
    updatedAt: string;
}

export interface Topic extends UserSummary {
    pk: string;
    sk: string;
    title: string;
    threadCount: number;
    createdAt: string;
    lastReplyAt: string;
    updatedAt: string;
}

// Denormalized parent content for replies (snapshot at reply time)
export interface QuotedThread extends UserSummary {
    sk: string; // The sk of the parent thread
    contentText?: string;
    mediaType?: ThreadMediaType;
    createdAt: string;
    updatedAt: string;
}

export interface Thread extends UserSummary {
    pk: string;
    sk: string;
    contentText?: string;
    mediaType?: ThreadMediaType;
    replyToThreadId?: string;
    quotedThread?: QuotedThread;
    createdAt: string;
    updatedAt: string;
    likes: Record<string, Like> | null;
}

export enum ThreadMediaType {
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
}
